import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import useScroll from "../hooks/useScroll";
import classNames from "classnames";
import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "gatsby";
import Logo from "./../images/logo.inline.svg";

const Header = ({ showCalendlyModal }) => {
  const { scrollY } = useScroll();
  return (
    <header className={classNames("header", { active: scrollY > 50 })}>
      <Navbar className="navbar navbar-expand-lg navbar-dark " expand="lg">
        <Container>
          <Link to="/" className="navbar-brand">
            <Logo width="224" />
          </Link>
          <Navbar.Toggle as="button" aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav as="ul" className="navbar-nav  ms-auto my-2 my-lg-0 ">
              <Nav.Item as="li">
                <Link to="/" className="nav-link" activeClassName="active">
                  Home
                </Link>
              </Nav.Item>
              <Nav.Item>
                <Link
                  to="/services"
                  className="nav-link"
                  activeClassName="active"
                >
                  Services
                </Link>
              </Nav.Item>
              <Nav.Item>
                <Link
                  to="/aboutUs"
                  className="nav-link"
                  activeClassName="active"
                >
                  About Us
                </Link>
              </Nav.Item>
              <Nav.Item>
                <Link to="/blog" className="nav-link" activeClassName="active">
                  Blogs
                </Link>
              </Nav.Item>
              <Nav.Item>
                <Link
                  to="/contactUs"
                  className="nav-link"
                  activeClassName="active"
                >
                  Contact Us
                </Link>
              </Nav.Item>
              <Nav.Item>
                <a
                  className="nav-link join-us btn btn-primary"
                  href="#"
                  style={{ textTransform: "none" }}
                  onClick={showCalendlyModal}
                >
                  Book Free Consultation
                </a>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
